import { module as modu } from 'modujs'
import { gsap } from 'gsap'

export default class extends modu {
  constructor(m) {
    super(m)
  }

  init() {
    this.move()
    this.texts()
  }

  move() {
    const box = this.el
    const position = { x: window.innerWidth * 0.5, y: window.innerHeight * 0.5 }
    let angle = Math.random() * 360

    gsap.set(box, { autoAlpha: 1, x: position.x, y: position.y })

    const animation = gsap.to(box, {
      duration: 1,
      repeat: -1,
      yoyo: true,
      onUpdate() {
        position.x += Math.cos((angle * Math.PI) / 180)
        position.y += Math.sin((angle * Math.PI) / 180)
        gsap.set(box, { x: position.x, y: position.y })

        const boxRect = box.getBoundingClientRect()
        if (boxRect.left <= 0 || boxRect.right >= window.innerWidth) {
          angle = 180 - angle
        }
        if (boxRect.top <= 0 || boxRect.bottom >= window.innerHeight) {
          angle = 360 - angle
        }
      },
    })
  }

  texts() {
    const words = ['body', 'equal', 'every', 'genders', 'equal', 'every']
    const colors = ['#FF7900', '#4200FF', '#00DB64', '#FF00D6', '#8135FF', '#EFC500']

    const element = this.el
    const span = this.el.querySelector('span')

    let currentWordIndex = 0
    let currentColorIndex = 0

    function changeTextAndColor() {
      span.textContent = words[currentWordIndex]
      element.style.backgroundColor = colors[currentColorIndex]

      currentWordIndex = (currentWordIndex + 1) % words.length
      currentColorIndex = (currentColorIndex + 1) % colors.length
    }

    setInterval(changeTextAndColor, 2000)
  }
}
